import { isTrackingEnabled } from './tracking';
/**
 * Track a custom event with Umami.
 * Safe to call even if Umami hasn't loaded yet — it will silently no-op.
 *
 * @param {string} eventName - Event name (e.g. 'demo-request-click')
 * @param {object} [data] - Optional event data
 */
export function trackEvent(eventName, data) {
  if (isTrackingEnabled() && window.umami) {
    try {
      Promise.resolve(window.umami.track(eventName, data)).catch(() => {});
    } catch {
      // Analytics must never interrupt navigation or form submission.
    }
  }
}
